var _path, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIsolateDrums = function SvgIsolateDrums(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.02 12.249a.75.75 0 1 0-1.5 0zm-1.5 0v5.988h1.5v-5.988zM18.062 11.618a.75.75 0 0 0-1.5 0zm-1.5 0v5.988h1.5v-5.988zM7.977 11.618a.75.75 0 0 0-1.5 0zm-1.5 0v5.988h1.5v-5.988z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.128 11.738c.452-.324.705-.685.705-1.065 0-.245-.105-.482-.3-.706h.3c.39 0 .706.316.706.706v5.042c0 .657-.4 1.17-.863 1.536-.471.371-1.11.675-1.835.917-1.458.486-3.428.774-5.571.774-2.144 0-4.114-.288-5.572-.774-.725-.242-1.363-.546-1.835-.917C4.4 16.886 4 16.372 4 15.715v-5.042c0-.39.316-.706.706-.706h.3c-.195.224-.3.46-.3.706 0 .38.253.741.706 1.065v3.977c0 .04.023.189.325.427.295.232.764.472 1.407.686 1.28.427 3.092.703 5.126.703s3.846-.276 5.125-.703c.643-.214 1.113-.454 1.407-.686.302-.238.326-.388.326-.427z",
    clipRule: "evenodd"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.27,
    cy: 10.673,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    rx: 7.564,
    ry: 2.521
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m19.49 4.479-7.641 5.649M17 2h3a2 2 0 0 1 2 2v3M2 7V4a2 2 0 0 1 2-2h3M7 22H4a2 2 0 0 1-2-2v-3M22 17v3a2 2 0 0 1-2 2h-3"
  })));
};
export default SvgIsolateDrums;